<form [formGroup]="form" class="feedback-modal" (ngSubmit)="submit()" novalidate *transloco="let t">
    <header class="feedback-modal__header">
        <h2 class="feedback-modal__title">{{ t('feedback.title') }}</h2>
        <button type="button" class="feedback-modal__close" (click)="close()" aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    </header>

    <section class="feedback-modal__body">
        <div class="form-group">
            <label class="field-label">{{ t('feedback.ratingQuestion') }}</label>

            <div class="rating-container">
                <button
                    *ngFor="let item of emojiItems"
                    type="button"
                    class="emoji-btn"
                    [class.active]="selectedEmoji === item.key"
                    (click)="selectEmoji(item.key)"
                    [title]="t('feedback.ratings.' + item.key)"
                >
                    <span class="emoji-icon">{{ item.emoji }}</span>
                    <span class="emoji-label">{{ t('feedback.ratings.' + item.key) }}</span>
                </button>
            </div>
        </div>

        <ck-multi-select
            formControlName="typeId"
            class="dark mb-0"
            [label]="t('feedback.typeLabel')"
            [data]="feedbackTypes()"
            [placeholder]="t('feedback.typePlaceholder')"
            idField="value"
            textField="label"
            [multiple]="false"
            [required]="true"
        ></ck-multi-select>

        <div class="form-group">
            <label class="hLabel">{{ t('feedback.commentsLabel') }}</label>

            <textarea
                rows="5"
                formControlName="comments"
                [placeholder]="t('feedback.commentsPlaceholder')"
                class="feedback-textarea">
            </textarea>
        </div>
    </section>

    <footer class="feedback-modal__footer">
        <button
            type="submit"
            class="btn btn--primary"
            [disabled]="loading || !form.dirty || form.invalid"
        >
            <span *ngIf="loading" class="btn__spinner"></span>
            {{ loading ? t('feedback.submitting') : t('feedback.submit') }}
        </button>
    </footer>
</form>
